module.exports = __webpack_public_path__ + "files/hays.012ca11a9d2f569810a98a91d54ad697.pdf";